import React from 'react'

import Avatar from '@mui/material/Avatar'
import Collapse from '@mui/material/Collapse'
import Divider from '@mui/material/Divider'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'

import { ChevronRight, ExpandLess, ExpandMore, Icon } from '@mxenabled/mx-icons'

import { useGlobalCopyStore } from '../../../common'
import { MetaType, TrackType } from '../../../core'
import { GoalType } from '../../../core/utils/GoalsUtil'

interface AddGoalListItemProps {
  goalType: GoalType
  onClick: (name: string, metaType: MetaType, type: TrackType) => void
}

export const AddGoalListItem = ({ goalType, onClick }: AddGoalListItemProps) => {
  const { goals: copy } = useGlobalCopyStore()
  const { bgcolor, icon, label, description, subTypes, type } = goalType

  const [isSubListOpen, setIsSubListOpen] = React.useState(false)
  const hasSubTypes = subTypes.length > 0

  return (
    <Stack>
      <List sx={{ bgcolor: 'background.paper' }}>
        <ListItem>
          <ListItemButton
            onClick={
              hasSubTypes
                ? () => setIsSubListOpen(!isSubListOpen)
                : () =>
                    onClick(
                      type === TrackType.RETIREMENT_TRACK ? copy.retirement : '',
                      type === TrackType.RETIREMENT_TRACK ? MetaType.RETIREMENT : MetaType.OTHER,
                      type,
                    )
            }
          >
            <ListItemAvatar>
              <Avatar sx={{ bgcolor }} variant="rounded">
                <Icon name={icon} sx={{ color: 'grey.900' }} />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={label} secondary={description} sx={{ mr: 24 }} />
            {!hasSubTypes && <ChevronRight />}
            {hasSubTypes && (isSubListOpen ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        </ListItem>
        <Divider variant="inset" />
        {hasSubTypes && (
          <Collapse in={isSubListOpen}>
            <List sx={{ bgcolor: 'background.default' }}>
              {subTypes.map((subType, index) => (
                <ListItem key={index} sx={{ pl: 48 }}>
                  <ListItemButton onClick={() => onClick(subType.label, subType.metaType, type)}>
                    <ListItemIcon sx={{ mr: 8 }}>
                      <Icon name={subType.icon} />
                    </ListItemIcon>
                    <ListItemText
                      primary={subType.label}
                      slotProps={{ primary: { variant: 'body1' } }}
                    />
                    <ChevronRight />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Collapse>
        )}
      </List>
    </Stack>
  )
}
